<template>
  <div id="common-review">
    <BaseReviewItem
      v-if="isRenderReviewItem"
      :sku-code="review.sku_code"
      :item-name="review.item_name" />
    <BaseReviewDetail
      :review-id="review.review_id"
      :star="review.star"
      :caption="review.caption"
      :description="review.description"
      :created="review.created"
      :nickname="review.nickname"
      :icon-url="review.customer_img"
      :is-link-to-detail="isLinkToDetail"
      :is-render-user-info="isRenderUserInfo"
      :account-status="review.official_user_status" />
    <BaseReviewImageThumbs
      :sku-code="review.sku_code"
      :images="review.images"
      :review-id="review.review_id" />
    <BaseReviewEvaluations
      :review-id="review.review_id"
      :count-helpful="review.count_helpful"
      :count-comment="review.count_comment"
      :is-link-to-detail="isLinkToDetail" />
    <BaseReviewActions
      :review-id="review.review_id"
      :helpful-id="review.is_entry_helpful_id"
      :clip-id="review.is_entry_clip_id"
      :is-entry-helpful="review.is_entry_helpful"
      :is-entry-clip="review.is_entry_clip"
      :nickname="review.nickname"
      :self-flag="review.selfFlag"
      @on-deleted="onDeleted"/>
  </div>
</template>

<script>
import BaseReviewItem from '@/components/BaseReviewItem'
import BaseReviewDetail from '@/components/BaseReviewDetail'
import BaseReviewImageThumbs from '@/components/BaseReviewImageThumbs'
import BaseReviewEvaluations from '@/components/BaseReviewEvaluations'
import BaseReviewActions from '@/components/BaseReviewActions'
export default {
  name: 'CommonReview',
  components: {
    BaseReviewItem,
    BaseReviewDetail,
    BaseReviewImageThumbs,
    BaseReviewEvaluations,
    BaseReviewActions
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    isRenderReviewItem: {
      type: Boolean,
      default: true
    },
    isRenderUserInfo: {
      type: Boolean,
      default: false
    },
    isLinkToDetail: {
      type: Boolean,
      default: true
    },
    isReviewDetail: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: Number,
      default: 0
    },
    accountStatus: {
      type: String,
      default: null
    }
  },
  methods: {
    onDeleted (data) {
      this.$emit('on-deleted', data) // 親画面へ通知
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommonReview.vue